import i18n from "../i18n";
import { Card, Group, Text, Badge, Paper, ActionIcon } from "@mantine/core";
import _ from "lodash";
import { useServerApi } from "../hooks/userServerApi";
import { useFormatter } from "../hooks/useFomatter";
import { useEffect, useState } from "react";
import ReactJson from "react-json-view";
import { IconRefresh } from "@tabler/icons";

const CommissionSettingFixAmountSchedule = ({
  commissionSetting,
  onRefresh,
}) => {
  const [formatter] = useFormatter();

  const fixCommission = commissionSetting?.fixCommission;
  return (
    <>
      {/* <ReactJson
        src={commissionSetting}
        name={"commissionSetting"}
        collapsed
        style={{ backgroundColor: "white" }}
      /> */}

      <Group mb="md">
        <Badge size="xs" color="blue" radius="xs">
          Fix Amount Schedule
        </Badge>
      </Group>
      <Card withBorder mb="md">
        <Paper withBorder p="xs">
          <Group position="apart">
            {!fixCommission && <Text size="xs">{i18n.t("No commission yet")}</Text>}
            {fixCommission && (
              <>
                <Text size="xs">
                  Net Commission:{" "}
                  {formatter.currency(
                    fixCommission.commission - fixCommission.exculsiveDiscount
                  )}
                </Text>
                <Text size="xs">
                  Commission: {formatter.currency(fixCommission.commission)}
                </Text>

                <Text size="xs">
                  Exl. Discount:{" "}
                  {formatter.currency(fixCommission.exculsiveDiscount)}
                </Text>
                <Text size="xs">
                  Rate: {(fixCommission.commissionRate * 100).toFixed(2)}%
                </Text>
              </>
            )}

            <ActionIcon size="sm" radius="xs" onClick={onRefresh}>
              <IconRefresh size={16} />
            </ActionIcon>
          </Group>
        </Paper>
      </Card>
    </>
  );
};

export default CommissionSettingFixAmountSchedule;
